import React from "react";

import type { LegalSection } from "./legal.types";
import LegalPageLayout from "./LegalPageLayout";

const intro = ["p1", "p2"] as const;

/** Section order and shape; the prose lives under `termsOfService` in the legal namespace. */
const sections: LegalSection[] = [
	{ key: "aboutTheService", paragraphs: ["p1"] },
	{ key: "notASourceOfTruth", paragraphs: ["p1", "p2"] },
	{ key: "yourAccount", paragraphs: ["p1", "p2"] },
	{ key: "yourContent", paragraphs: ["p1", "p2", "p3", "p4", "p5"] },
	{
		key: "copyrightComplaints",
		listItems: ["i1", "i2", "i3", "i4", "i5", "i6"],
		paragraphs: ["p1", "p2"],
		trailingParagraphs: ["p3", "p4", "p5", "p6"]
	},
	{ key: "acceptableUse", listItems: ["i1", "i2", "i3", "i4", "i5", "i6"], paragraphs: ["p1"] },
	{ key: "subscriptionsAndPayments", paragraphs: ["p1", "p2", "p3", "p4", "p5"] },
	{ key: "intellectualProperty", paragraphs: ["p1"] },
	{ key: "thirdPartyServices", paragraphs: ["p1"] },
	{ key: "suspensionAndTermination", paragraphs: ["p1"] },
	{ key: "disclaimerOfWarranties", paragraphs: ["p1"] },
	{ key: "limitationOfLiability", paragraphs: ["p1", "p2"] },
	{ key: "indemnity", paragraphs: ["p1"] },
	{ key: "changesToTerms", paragraphs: ["p1"] },
	{ key: "governingLaw", paragraphs: ["p1"] },
	{ key: "contactUs", paragraphs: ["p1"] }
];

const TermsOfServicePage = () => {
	return <LegalPageLayout intro={intro} page="termsOfService" sections={sections} />;
};

export default TermsOfServicePage;
